import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './About.module.scss'
// components
import Title from '../images/svg/head_about.svg'
import Logo from '../images/svg/logo_happysunny.svg'
import Button from './Button'

const About = () => (
    <section name="about" className={styles.wrapper}>
        <div className={styles.container}>
            <h2 className="sr-only">制作実績</h2>
            <div className={styles.head}>
                <Title />
            </div>
            <div className={styles.items}>
                <div className={styles.item}>
                    <div className={styles.logo}>
                        <Logo />
                    </div>
                </div>
                <div className={styles.item}>
                    <table>
                        <tbody>
                            <tr>
                                <td>会社名</td>
                                <td>株式会社Happy Sunny </td>
                            </tr>
                            <tr>
                                <td>英文法人名</td>
                                <td>Happy Sunny &amp; Co.</td>
                            </tr>
                            <tr>
                                <td>本社所在地</td>
                                <td>〒151-0066<br />
                                    東京都渋谷区西原2-35-1 ブランエール代々幡 101
                                </td>
                            </tr>
                            <tr>
                                <td>TEL/FAX</td>
                                <td>TEL: 03-6434-5967<br />FAX: 03-3478-3255</td>
                            </tr>
                            <tr>
                                <td>代表取締役 CEO</td>
                                <td>井上翼</td>
                            </tr>
                            <tr>
                                <td>創業年月日</td>
                                <td>2018年10月12日</td>
                            </tr>
                            <tr>
                                <td>資本金</td>
                                <td>300万円</td>
                            </tr>
                            <tr>
                                <td>主要取引先</td>
                                <td>株式会社ルネサンス / 株式会社ティップネス / 株式会社プラチナムプロダクション / 株式会社 RIZAP / 大同生命保険株式会社 / 株式会社ユニマットプレシャス / ワンオブゼム株式会社 / チズコーポレーション株式会社 / トリピュアジャパン株式会社 / ヒルトンリゾーツマーケティングコーポレーション株式会社</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className={styles.buttonWrapper}>
                <Button 
                    title="Contact us"
                    link="info@happysunny.net"
                    type="mailto"
                    className={styles.button}
                />
            </div>
        </div>
    </section>
)

export default About;
